import React, { useContext } from 'react'
import AppStateContext from '../../../hooks/AppStateContext'
import { useRouterHistory, PluginContext } from '@flamingo_tech/funkgo'

import Link from '../../common/Link/Link'
import Button from '../../common/Button/PlainButton'
import Pressable from '../../common/Pressable/Pressable'

import styles from './StoreHeader.module.css'

const StoreHeader = props => {
  const { historyLength } = useRouterHistory()
  const plugin = useContext(PluginContext)
  const $i18n = plugin.$i18n

  const appState = useContext(AppStateContext)
  const { site } = appState
  const {
    displaySearch = false,
    displayBack = true,
    displayCart = true,
    displayNavi = true,
    displayShare = false,
    cartLineItemCount = 0,
    onCartClick,
    onShareClick,
    onNaviClick,
  } = props

  const handleBack = () => {
    props.$track.event('StoreHeader', 'click_back')
    props.$router.goBack()
  }

  const leftElements = []
  const rightElements = []


  const renderTitle = () => {
    if (props.headerTitle) {
      return (
        <Link
          block to='Home'
          className={styles.title}
        >
          {props.headerTitle}
        </Link>
      )
    }

    return (
      <Link
        key='logo'
        block to='Home'
        className={styles.logoBar}
        style={logoStyle}
        ariaLabel={$i18n.transl('common.home')}
      >
      </Link>
    )
  }

  if (historyLength > 1 && displayBack) {
    leftElements.push(
      <Pressable
        key='back'
        className={styles.backIcon}
        onClick={handleBack}
        ariaLabel={$i18n.transl('common.back')}
      />
    )
  }

  if (displayNavi) {
    leftElements.push(
      <Button
        key='navi'
        className={styles.naviBtn}
        onClick={onNaviClick}
        ariaLabel={$i18n.transl('shell.header.openMenu')}
      ><i className={styles.naviIcon} aria-hidden="true">&#xe606;</i></Button>
    )
  }

  if (displaySearch) {
    leftElements.push(
      <Link
        key='search'
        to='SearchPage'
        className={styles.search}
        ariaLabel={$i18n.transl('shell.header.searchProducts')}
      >
        <div
          id='header_search'
        >
          <i className={styles.searchIcon} aria-hidden="true">&#xe60b;</i>
        </div>
      </Link>
    )
  }

  if (displayCart !== false) {
    rightElements.push(
      <Pressable
        id="atc_parabola_destination_with_shake"
        key='cart'
        className={styles.cart}
        onClick={onCartClick}
        ariaLabel={$i18n.transl('core.cart.shoppingCart')}
      >
        <i className={styles.cartIcon} aria-hidden="true">&#xe61c;</i>
        {
          cartLineItemCount > 0 && (
            <div className={styles.cartCount} aria-hidden="true">
              <span>{cartLineItemCount > 99 ? '99+': cartLineItemCount}</span>
            </div>
          )
        }
      </Pressable>
    )
  }

  if (displayShare === true) {
    rightElements.push(
      <Pressable
        key='share'
        className={styles.share}
        onClick={onShareClick}
        ariaLabel={$i18n.transl('common.share')}
      />
    )
  }

  const logoStyle = {}
  const headerStyle = {}

  if (site.logo) {
    logoStyle["backgroundImage"] = `url(${site.logo})`
  }

  if (props.headerTheme) {
    headerStyle.backgroundColor = props.headerTheme
  }

  const header = (
    <header className={styles.header} style={headerStyle} key="header" id="store-header">
      <aside onClick={e => e.preventDefault()}>
        {leftElements}
      </aside>
      {renderTitle()}
      <aside>
        {rightElements}
      </aside>
    </header>
  )

  return header
}

export default StoreHeader
